export default __webpack_public_path__ + "images/0xf24bcf4d1e507740041c9cfd2dddb29585adce1e.png";